// Core
import React, { useEffect, useState } from 'react';
import { Row, Col, Table, Spin, Tooltip, Form, Input, InputNumber, Select, notification } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import { RecordFormWrapper } from './Style';
// App
import { Modal } from '../../../components/modals/antd-modals';
import { RecordViewWrapper } from './Style';
import { Main, TableWrapper, BasicFormWrapper } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { PageHeader } from '../../../components/page-headers/page-headers';
import { pagosRegistradosListAction } from '../../../redux/finanzas/pagosRegistrados/actionCreator'

import { sucursalListAction } from '../../../redux/administracion/sucursales/actionCreator'
import { servicioListAction } from '../../../redux/administracion/servicios/actionCreator';

const PagosRegistradosViewPage = () => {
  const dispatch = useDispatch();    
  const isLoading = useSelector(state => state.responseReducer.loading);
  const registros = useSelector(state => state.PagosRegistradosCrudReducer.data);

  const catalogoSucursales = useSelector(state => state.SucursalReducer.dataSelectBox);
  const catalogoFormasPago = useSelector(state => state.CatalogosReducer.formasPago);
  const catalogoServicios = useSelector(state => state.ServicioReducer.dataSelectBox);

  const [form] = Form.useForm();

  useEffect(() => { 
   
    const params = {
      fecha_inicio: '',
      fecha_fin: '',
      saldo: '',
      idSucursal: '',
      idServicio: '',
      idFormaPago: ''
    };
    
    if (pagosRegistradosListAction) {
      dispatch(pagosRegistradosListAction(params));
      dispatch(sucursalListAction());
      dispatch(servicioListAction('administracion'));
    }
  }, [dispatch]);

  const dataSource = []; // Este sera el arreglo de datos que usa la tabla para mostrar el listado de registros

  const onHandleSearch = e => {
    dispatch(pagosRegistradosListAction(e.target.value));
  };

  const handleSubmit = async (values) => { 
   
    const params = {
      fecha_inicio: !!values.fecha_inicio == false ? '' : values.fecha_inicio.trim(),
      fecha_fin:    !!values.fecha_fin == false ? '': values.fecha_fin.trim(),
      saldo:        !!values.saldo == false ? '': values.saldo.trim(),
      idSucursal:   !!values.idSucursal == false ? '': values.idSucursal.trim(),
      idServicio:   !!values.idServicio == false ? '': values.idServicio.trim(),
      idFormaPago:  !!values.idFormaPago == false ? '': values.idFormaPago.trim()
    };
    
    dispatch(pagosRegistradosListAction(params));

    form.resetFields();

  };

  if (registros.length)
    registros.map((record, key) => {      
      const { id, fecha, nombreSucursal,monto, nombrePaciente, paternoPaciente } = record; // Aqui se mapean las propiedades/columnas que el API respondera
      return dataSource.push({
        key: key + 1,
        fecha,
        nombreSucursal, 
        nombrePaciente: nombrePaciente + ' ' + paternoPaciente,                
        monto,                    
        action: (
          <div className="table-actions">
            <Tooltip title="Ver Detalle" color="#f8f9ac">
              <Link to={`/admin/finanzas/pagos-registrados/ver-detalle/${id}`}>
                <Button>
                  <FeatherIcon icon="eye" />
                </Button>
              </Link>
            </Tooltip>                                             
          </div>
        ),
      });
    });

    // Estas son las columnas que se utilizaran para armar la tabla
  const columns = [
    {
      title: 'Fecha',
      dataIndex: 'fecha',
      key: 'fecha',
    },  
    {
      title: 'Sucursal',
      dataIndex: 'nombreSucursal',
      key: 'nombreSucursal',
    }, 
    {
      title: 'Paciente',
      dataIndex: 'nombrePaciente',
      key: 'nombrePaciente',
    },  
    {
      title: 'Monto',
      dataIndex: 'monto',
      key: 'monto',
    }, 
    {
      title: 'Acciones',
      dataIndex: 'action',
      key: 'action',
      width: '90px',
    },
  ];

  return (
    <RecordViewWrapper>
      <PageHeader
       
        title={
          <div>
           <p>PAGOS REGISTRADOS</p>
           <p>FILTRAR POR:</p>
           </div>
        }
       
      />
      <Main>

        <Row gutter={15}>

        <Col xs={24}>
            <Form
              layout="vertical"
              size="small"
              form={form}
              onFinish={handleSubmit}
            >
              <RecordFormWrapper>
                <Cards headless>
                  <BasicFormWrapper>                  
            <Form.Item>
            <Input.Group compact>

            <Form.Item name="fecha_inicio" label="Fecha inicio (dd-mm-yyyy)" rules={[ { pattern: /^\d{2}-\d{2}-\d{4}$/,  message: 'Escríbe la fecha en el formato indicado' }]} >
                <Input placeholder='Ej. 02-28-1980' style={{ width: '250px', margin: '0 7px' }} />

              </Form.Item>

              <Form.Item name="fecha_fin" label="Fecha fin (dd-mm-yyyy)" rules={[ { pattern: /^\d{2}-\d{2}-\d{4}$/, message: 'Escríbe la fecha en el formato indicado' }]} >
                <Input placeholder='Ej. 02-28-1980' style={{ width: '250px', margin: '0 7px' }} />
              </Form.Item>

              <Form.Item name="saldo" label="Saldo" rules={ [{ pattern: "^[0-9]*$", message: 'Solo se aceptan números.' } ] }>
                      <Input placeholder="Ej. 20" />
              </Form.Item> 

            </Input.Group>

          </Form.Item>  

          <Form.Item>
            <Input.Group compact>

              <Form.Item name="idSucursal" label="Sucursal donde labora" >
                      <Select placeholder="Selecciona..." options={catalogoSucursales} notFoundContent={'Sin registros'}  style={ { width: '250px', margin: '0 7px', height:'10px!important' } }  />
              </Form.Item>

                <Form.Item name="idServicio" label="Servicio" rules={[{ required: false }]}>
                     <Select placeholder="Selecciona..." options={catalogoServicios} notFoundContent={'Sin registros'} style={{ width: '250px', margin: '0 7px', height:'10px!important' }} />
                </Form.Item>

                <Form.Item name="idFormaPago" label="Forma de pago" rules={[{ required: false }]}>
                     <Select placeholder="Selecciona..." options={catalogoFormasPago} notFoundContent={'Sin registros'} style={{ width: '250px', margin: '0 7px', height:'10px!important' }} />
                </Form.Item>

            </Input.Group>
          </Form.Item> 
                  </BasicFormWrapper>
                  <br />
                  <div className="record-form-actions text-right">
                    <Button size="default" htmlType="Save" type="primary">
                      {isLoading ? 'Cargando...' : 'Buscar'}
                    </Button>
                  </div>
                </Cards>
              </RecordFormWrapper>
            </Form>
          </Col>


          <Col className="w-100" md={24}>
            <Cards headless>        
              {isLoading ? (
                <div className="spin">
                  <Spin size='large' />
                </div>
              ) : (
                <div>
                  <TableWrapper className="table-data-view table-responsive">
                    <Table
                      pagination={{ pageSize: 40, showSizeChanger: true }}
                      dataSource={dataSource}
                      columns={columns}
                      locale={{ emptyText: 'Sin registros' }}
                    />
                  </TableWrapper>
                </div>
              )}
            </Cards>
          </Col>
        </Row>
      </Main>
    </RecordViewWrapper>
  );
};

export default PagosRegistradosViewPage;
